import React from 'react'
import { compose } from 'recompose'

import IconButton from 'components/Utils/IconButton'
import { CloseIcon } from 'components/Utils/Icons'
import { withNoteMetaPanelControls } from 'routes/utils/withNoteMetaPanelControls'

function ExitButton({ hideComments }) {
  return (
    <div onClick={hideComments}>
      <IconButton>
        <CloseIcon size={16} />
      </IconButton>
    </div>
  )
}

export default compose(withNoteMetaPanelControls)(ExitButton)
